module.exports = __webpack_public_path__ + "img/deving.c3c3faed.png";